import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import ModalDialog from '../modal-dialog/ModalDialog'
import { messages } from '../Message'

const TITLE = 'לא ניתן לסמן לדיוור'

const CLOSE_LABEL = 'סגירה'

// Carries no way to proceed. An opt-out an accountant can reverse with a checkbox is not
// an opt-out, so this tells the user what happened and offers them nothing else.
export default function UnsubscribedNotice({ open = false, detail = null, onClose }) {
    return (
        <ModalDialog
            open={open}
            title={TITLE}
            commands={[{ label: CLOSE_LABEL, color: 'secondary', onClick: onClose }]}
            onClose={onClose}
        >
            <MDBox display="flex" flexDirection="column" gap="0.75rem">
                <MDTypography variant="body2">
                    {messages.CONSENT_UNSUBSCRIBED}
                </MDTypography>

                {detail?.value != null && (
                    <MDTypography variant="body2" fontWeight="medium">
                        {`הפרט: ${detail.value}`}
                    </MDTypography>
                )}
            </MDBox>
        </ModalDialog>
    )
}
